<template>
  <div class="grid-container fluid no-padding">
    <div v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="hero">
      <div class="grid-container">
        <div class="animated bounceInUp grid-x inside">
          <div class="down-float" id="scroll-down-indicator">
            <i class="fas fa-chevron-down"></i>
          </div>
          <div id="mobile-slide" class="show-for-small-only cell small-12 medium-6 do-centering">
            <transition-group 
              name="fade"
              v-bind:css="false"
              v-on:before-enter="beforeEnter"
              v-on:enter="enter"
              v-on:before-leave="beforeLeave"
              v-on:leave="leave">
              <img :key="0" style="max-width:260px;" v-show="hero_img.count === 0" :class="['tr-float', {'no-animation': hero_img.count !== 0}]" :src="getImgUrl('img/logo.svg')" alt="">              
              <img :key="1" v-show="hero_img.count === 1" :class="['tr-float', {'no-animation': hero_img.count !== 1}]" :src="getImgUrl('img/truck-extra.png')" alt="">
              <img :key="2" v-show="hero_img.count === 2" :class="['tr-float', {'no-animation': hero_img.count !== 2}]" :src="getImgUrl('img/airplane-extra.png')" alt="">
              <img :key="3" v-show="hero_img.count === 3" :class="['tr-float', {'no-animation': hero_img.count !== 3}]" :src="getImgUrl('img/ship-extra.png')" alt="">
            </transition-group>
          </div>
          <div id="brand-headertext" class="cell small-12 medium-6 text-left do-centering">
            <section class="show-for-medium">
              <h1>{{ $t("hero.brand") }}</h1>
              <h5>{{ $t("hero.subtitle") }}</h5>
            </section>
            <section class="show-for-small-only">
              <h2>{{ $t("hero.subtitle") }}</h2>
              <h5>- <b>{{ $t("hero.brand") }}</b></h5>
            </section>
          </div>
          <div class="show-for-medium cell medium-6 do-centering">
            <transition-group 
              name="fade"
              v-bind:css="false"
              v-on:before-enter="beforeEnter"
              v-on:enter="enter"
              v-on:before-leave="beforeLeave"
              v-on:leave="leave">
              <img :key="0" style="max-width:260px;" v-show="hero_img.count === 0" :class="['tr-float', {'no-animation': hero_img.count !== 0}]" :src="getImgUrl('img/logo.svg')" alt="">              
              <img :key="1" v-show="hero_img.count === 1" :class="['tr-float', {'no-animation': hero_img.count !== 1}]" :src="getImgUrl('img/truck-extra.png')" alt="">
              <img :key="2" v-show="hero_img.count === 2" :class="['tr-float', {'no-animation': hero_img.count !== 2}]" :src="getImgUrl('img/airplane-extra.png')" alt="">
              <img :key="3" v-show="hero_img.count === 3" :class="['tr-float', {'no-animation': hero_img.count !== 3}]" :src="getImgUrl('img/ship-extra.png')" alt="">
            </transition-group>
          </div>
        </div>
      </div>
    </div>

    <div v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="services" class="space-top space-bottom">
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell"><h3 class="section-header">{{ $t("service.title") }}</h3></div>
          <card v-for="(service, key) in services" :key="key" :route="key" :title="$t(`service.${key}.title`)" :brief="$t(`service.${key}.brief`)" :img="service.img" />
        </div>
      </div>
    </div>

    <div v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="whyus" class="space-top space-bottom">
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell"><h3 class="section-header">{{ $t('whyus.title') }}</h3></div>
          <advantage-card v-for="(reason, index) in whyus" :key="index" :title="$t(`whyus.${reason.title}.topic`)" :content="$t(`whyus.${reason.title}.content`)" :img="reason.img" />
        </div>
      </div>
    </div>

    <div v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="gallery" class="space-top space-bottom">
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell" id="gallery-showcase">
            <div v-for="(thisImage, index) in img" :key="index" class="img-gallery">
              <img :src="thisImage">
            </div>
            <div class="img-gallery">
              <router-link :to="{name: 'Gallery'}" tag="button" class="c-1 button margin-top do-centering-object">{{ $t('gallery.more') }}</router-link>                
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="contact" class="space-top space-bottom">
      <div class="grid-container">
        <div class="grid-x box-shadow">
          <div class="cell small-12 medium-6 large-4 text-left space-1">
            <h3 class="section-header">{{ $t('contact.title') }}</h3>
            <h4>{{ $t('contact.headOffice') }}</h4>
            <p>{{ $t('contact.address[0]') }}<br>{{ $t('contact.address[1]') }}</p>
            <p><b>{{ $t('contact.phone') }} :</b> 081-908-0996</p>
            <p><b>{{ $t('contact.email') }} :</b> nuanchan@louislogistics.com</p>
          </div>
          <div class="cell small-12 medium-6 large-8">
            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3877.14691074913!2d100.71630401519921!3d13.648825990414167!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x311d5ddaf9bc2951%3A0x5a00a4ebcd8a02fa!2sLouis+Logistics!5e0!3m2!1sen!2sth!4v1548003865198" frameborder="0" style="width: 100%; height: 100%; border:0" allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>

    <div v-if="isReady.timeout" v-observe-visibility="{callback: visibilityChanged, intersection: options}" id="today" class="space-top space-bottom">
      <div class="grid-container">
        <div class="grid-x grid-margin-x">
          <div class="cell"><h3 class="section-header">{{ $t('today.title') }}</h3></div>
          <div v-if="isReady.oilData" class="cell small-12 medium-auto">
            <table class="unstriped">
              <thead>
                <tr>
                  <th class="text-left">{{ $t('today.oil.type') }}</th>
                  <th class="text-center font-color-blue" width="50">{{ $t('today.oil.today') }}</th>
                  <th class="text-center" width="50">{{ $t('today.oil.tomorrow') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="oil in oilData" :key="oil.type">
                  <td class="text-left"><img  class="margin-right oil-img show-for-medium" :src="oil.image" alt="">{{ oil.type }}</td>
                  <td class="text-center font-color-blue">{{ oil.today }}</td>
                  <td class="text-center">{{ oil.tomorrow }}</td>
                </tr>
                <tr>
                  <td class="text-left">{{ $t('today.oil.datafrom') }} https://www.bangchak.co.th</td>
                  <td class="text-center" colspan="2">{{ $t('today.oil.unit') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div v-if="isReady.currencyData" class="cell small-12 medium-auto">
            <table class="unstriped">
              <thead>
                <tr>
                  <th class="text-left">{{ $t('today.currency.currency') }}</th>
                  <th class="text-center font-color-blue" width="50">{{ $t('today.currency.selling') }}</th>
                  <th class="text-center" width="50">{{ $t('today.currency.buying') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(currency, key) in currencyData" :key="key">
                  <td class="text-left">
                    <p class="no-margin font-color-blue">{{ currency.result.data.data_detail[0].currency_id }}</p>
                    <small v-if="$i18n.locale === 'en'">{{ currency.result.data.data_detail[0].currency_name_eng }}</small>
                    <small v-else>{{ currency.result.data.data_detail[0].currency_name_th }}</small>
                  </td>
                  <td class="text-center font-color-blue">{{ formatRate(currency.result.data.data_detail[0].selling) }}</td>
                  <td class="text-center">{{ formatRate(currency.result.data.data_detail[0].buying_sight) }}</td>
                </tr>
                <tr>
                  <td class="text-left">{{ $t('today.currency.datafrom') }} https://www.bot.or.th</td>
                  <td class="text-center" colspan="2">{{ $t('today.currency.unit') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import Velocity from 'velocity-animate'
import axios from 'axios'
import Card from '@/components/Card'
import AdvantageCard from '@/components/AdvantageCard'
export default {
  metaInfo: {
    title: 'Home'
  },
  name: 'home',
  components: {Card, AdvantageCard},
  mounted () {

    setTimeout(() => {
      if (this.$route.params.to) {
        this.$SmoothScroll(this.getElementPosition(document.getElementById(this.$route.params.to)))      
      }
      this.isReady.timeout = true
    }, 1000)

    this.getOilData()
    this.getRate()
    this.changeHeroImage()

  },
  data () {
    return {
      img: [
        require('../assets/img/feed-1.png'),
        require('../assets/img/feed-2.png'),
        require('../assets/img/feed-3.png'),
        require('../assets/img/feed-4.jpg'),
        require('../assets/img/feed-5.png')
      ],
      options: {
        threshold: 0.65
      },
      isReady: {
        currencyData: false,
        oilData: false,
        timeout: false
      },
      hero_img: {
        count: 0,
        link: ''
      },
      services: {
        warehouse: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dignissim volutpat eros eu malesuada. Proin ultrices tellus metus, nec tempus sapien fermentum ac. Fusce cursus convallis nunc. Morbi ex felis, ornare non ex non, malesuada bibendum lacus. Mauris semper, tellus sit amet pellentesque lacinia, est risus ornare ipsum, vel congue quam s',
          img: require('../assets/img/warehouse.png')
        },
        transportation: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dignissim volutpat eros eu malesuada. Proin ultrices tellus metus, nec tempus sapien fermentum ac. Fusce cursus convallis nunc. Morbi ex felis, ornare non ex non, malesuada bibendum lacus. Mauris semper, tellus sit amet pellentesque lacinia, est risus ornare ipsum, vel congue quam s',
          img: require('../assets/img/truck.png')
        },
        shipping: {
          text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Mauris dignissim volutpat eros eu malesuada. Proin ultrices tellus metus, nec tempus sapien fermentum ac. Fusce cursus convallis nunc. Morbi ex felis, ornare non ex non, malesuada bibendum lacus. Mauris semper, tellus sit amet pellentesque lacinia, est risus ornare ipsum, vel congue quam s',
          img: require('../assets/img/shipping.png')
        },
        freight: {
          img: ''
        }
      },
      whyus: [
        {title: 'tm', img: require('../assets/img/ad-tm.png')},
        {title: 'ex', img: require('../assets/img/ad-ex.png')},
        {title: 'mm', img: require('../assets/img/ad-mm.png')},
        {title: 'hp', img: require('../assets/img/ad-hp.png')}
      ],
      oilData: [],
      currencyData: {
        JPY: null,
        USD: null,
        GBP: null
      },
      onViewPort: ''
    }
  },
  methods: {
    getElementPosition (element) {
      let yPosition = 0
      while(element) {
        yPosition += (element.offsetTop - element.scrollTop + element.clientTop)
        element = element.offsetParent
      }
      return yPosition - document.getElementById("top-menu").scrollHeight
    },
    visibilityChanged (entering, entry) {
      return 0
    },
    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.height = 0
    },
    enter: function (el, done) {
      let delay = el.dataset.index * 150
      el.style.height = '100%'
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 1 },
          { complete: done }
        )
      }, delay)
    },
    beforeLeave: function (el) {
      el.style.opacity = 0
      el.style.display = 'none'
    },
    leave: function (el, done) {
      let delay = el.dataset.index * 150
      setTimeout(function () {
        Velocity(
          el,
          { opacity: 0, height: 0 },
          { complete: done }
        )
      }, delay)
    },
    changeHeroImage () {
      setInterval(() => {
        if (this.hero_img.count == 3) {
          this.hero_img.count = 0
        } else {
          this.hero_img.count++
        }
      }, 4000)
    },
    getImgUrl(pic) {
        return require('../assets/'+pic)
    },
    getOilData () {
      axios.get('https://crmmobile.bangchak.co.th/webservice/oil_price.aspx').then(res  => {
        let data = new DOMParser().parseFromString(res.data, "text/xml")
        Array.from(data.getElementsByTagName('item')).forEach(item => {
          this.oilData.push({
            type: item.getElementsByTagName('type')[0].innerHTML,
            today: item.getElementsByTagName('today')[0].innerHTML,
            tomorrow: item.getElementsByTagName('tomorrow')[0].innerHTML,
            image: item.getElementsByTagName('image')[0].innerHTML,
            unit_th: item.getElementsByTagName('unit_th')[0].innerHTML,
            unit_en: item.getElementsByTagName('unit_en')[0].innerHTML
          })
          this.isReady.oilData = true
        })
      })
    },
    formatRate (rate) {
      return parseFloat(rate).toFixed(2);
    },
    getRate () {
      let date = new Date()
      let today = date.getUTCFullYear()+'-'+('0' + (date.getMonth()+1)).slice(-2)+'-'+('0' + date.getDate()).slice(-2)
      let pastDate = new Date(Date.now()-604800000)
      pastDate = pastDate.getUTCFullYear()+'-'+('0' + (pastDate.getMonth()+1)).slice(-2)+'-'+('0' + pastDate.getDate()).slice(-2)
      const base = ['JPY', 'USD', 'GBP']
      base.forEach(currency => {
        axios.get(
          "https://apigw1.bot.or.th/bot/public/Stat-ExchangeRate/v2/DAILY_AVG_EXG_RATE/?start_period=" + pastDate + "&end_period=" + today + "&currency=" + currency, {
            headers: {
              'x-ibm-client-id': '8523775b-ab29-4dda-bf85-60f939c2de6c'
            }
          }
        ).then(res => {
          this.currencyData[currency] = res.data
          this.isReady.currencyData = Object.keys(this.currencyData).every(x => x !== null)
        })
      })
    },
    trimContent (content) {
      return (content + '').substring(0, 300) + "..."
    }
  }
}
</script>

<style lang="scss" scoped>
#hero {
  height: 100vh;
  overflow: hidden;
  background-image: url('../assets/img/airplane-bg.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  .grid-container {
    min-height: 100vh;
  }
  .inside {
    min-height: 100vh;
  }
  .tr-float {
    animation: float 6s ease-in-out infinite;
    max-width: 270px;
    margin: 0 auto;
        width: 100%;
  }
}

#whyus {
  background-image: url('../assets/img/truck-bg.png');
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

.section-header {
  font-weight: bold;
  margin-bottom: 1em;
  margin-top: 0em;
}

.down-float {
  animation: float2 6s ease-in-out infinite;
  margin: 0 auto;
  width: 100%;
}

.oil-img {
  border-radius: 10px;
}

#brand-headertext {
  padding-left: 10%;
  padding-right: 0%;
}

@media screen and (max-width: 640px) {
  #brand-headertext {
    padding-right: 10%;
  }
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

#gallery-showcase {
  /* Prevent vertical gaps */
  line-height: 0;
  column-count: 3;
  column-gap: 5px;
  .img-gallery {
    button {
      margin: 0;
      width: 100%;
    }
    width: 100% !important;
    height: auto !important;
    padding-bottom: 5px;
  }
}

@media (max-width: 800px) {
  #gallery-showcase {
    -moz-column-count: 2;
    -webkit-column-count: 2;
    column-count: 2;
  }
}

#mobile-slide {
  justify-content: flex-end;
}

#scroll-down-indicator {
  position: absolute;
  bottom: 0;
  width: 100%;
  padding-bottom: 1em;
  i {
    font-size: 2em;
  }
}
</style>

